import { render, staticRenderFns } from "./DistributionBranchFormComponent.vue?vue&type=template&id=13c40435"
import script from "./DistributionBranchFormComponent.vue?vue&type=script&lang=js"
export * from "./DistributionBranchFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports